<template>
  <article>
    <header
            class="pe-20 relative cursor-pointer group mb-4"
            @click="open = !open"
    >
      <h3 class="article-title text-secondary group-hover:text-secondary-dark">
        {{ page.title }}
      </h3>
      <button class="absolute top-0 bottom-0 my-auto end-0 text-secondary group-hover:text-secondary-dark"
              type="button">
        <ChevronDownIcon
                :class="{'rotate-180': open, 'rotate-0': !open}"
                aria-hidden="true"
                class="-mr-1 size-5 transition-transform"
        />
      </button>
    </header>
    <ContentRenderer
            :class="{
              'max-h-0 overflow-hidden opacity-0 -translate-y-1/2': !open,
              'max-h-[2000px] opacity-100 translate-y-0': open
            }"
            :value="page"
            class="with-free-text transition-all"
    />
  </article>
</template>

<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";
import {ChevronDownIcon} from "@heroicons/vue/20/solid";

const {page} = defineProps<{
    page: PageCollectionItemBase;
}>();
const open = ref<boolean>(false);
</script>